export interface Credentials {
  readonly email: string;
  readonly password: string;
}

export interface CredentialErrors {
  readonly email?: string;
  readonly password?: string;
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value: string): boolean => EMAIL_PATTERN.test(value.trim());

/** The sign-in form's rules; an empty object means the draft may be submitted. */
export function validateCredentials(draft: Credentials): CredentialErrors {
  const errors: { email?: string; password?: string } = {};
  if (!isValidEmail(draft.email)) errors.email = "Enter a valid email address.";
  if (draft.password.trim() === "") errors.password = "Enter your password.";
  return errors;
}

export const hasCredentialErrors = (errors: CredentialErrors): boolean =>
  errors.email !== undefined || errors.password !== undefined;
